/**
 * @file ResetPassword.ts
 * @description
 * -----------------------------------------------------
 * Schema para ResetPassword
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-01-15
 * @modified 2026-01-22
 * @author Correcta
 * @author Sergio Manjón
 * @copyright © Correcta
 * @license Private
 **/
import { z } from "zod";

export const ResetPasswordSchema = z.object({
  mail: z.string().email({ message: "mailInvalid" }),
});

export const ResPassSchema = z
  .object({
    password: z
      .string()
      .min(8, "passwordMinLength")
      .refine((val) => /[a-z]/.test(val), {
        message: "passwordLowerCase",
      })
      .refine((val) => /[A-Z]/.test(val), {
        message: "passwordUpperCase",
      })
      .refine((val) => /[0-9]/.test(val), {
        message: "passwordDigit",
      })
      .refine((val) => /[[!@#$%^&*()_+{}:;<>,.?/~\-=|]/.test(val), {
        message: "passwordSpecialChar",
      }),
    repeatPassword: z.string(),
  })
  .refine((data) => data.password === data.repeatPassword, {
    path: ["repeatPassword"],
    message: "passwordsDoNotMatch",
  });

export const ChangePasswordSchema = z
  .object({
    oldPassword: z
      .string()
      .min(8, "passwordMinLength")
      .refine((val) => /[a-z]/.test(val), {
        message: "passwordLowerCase",
      })
      .refine((val) => /[A-Z]/.test(val), {
        message: "passwordUpperCase",
      })
      .refine((val) => /[0-9]/.test(val), {
        message: "passwordDigit",
      })
      .refine((val) => /[[!@#$%^&*()_+{}:;<>,.?/~\-=|]/.test(val), {
        message: "passwordSpecialChar",
      }),
    newPassword: z
      .string()
      .min(8, "passwordMinLength")
      .refine((val) => /[a-z]/.test(val), {
        message: "passwordLowerCase",
      })
      .refine((val) => /[A-Z]/.test(val), {
        message: "passwordUpperCase",
      })
      .refine((val) => /[0-9]/.test(val), {
        message: "passwordDigit",
      })
      .refine((val) => /[[!@#$%^&*()_+{}:;<>,.?/~\-=|]/.test(val), {
        message: "passwordSpecialChar",
      }),
    confirmPassword: z
      .string()
      .min(8, "passwordMinLength")
      .refine((val) => /[a-z]/.test(val), {
        message: "passwordLowerCase",
      })
      .refine((val) => /[A-Z]/.test(val), {
        message: "passwordUpperCase",
      })
      .refine((val) => /[0-9]/.test(val), {
        message: "passwordDigit",
      })
      .refine((val) => /[[!@#$%^&*()_+{}:;<>,.?/~\-=|]/.test(val), {
        message: "passwordSpecialChar",
      }),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "repeatPasswordMismatch",
    path: ["confirmPassword"],
  });
